// Shared hook for calendar name mapping
import { useMemo } from 'react';
import { useAccessibleCalendars } from './useDiaryManagementData';

/**
 * Hook that provides a map of calendar email -> calendar name
 * Shared across all diary management components to avoid redundant computation
 */
export const useCalendarNameMap = () => {
  const { data: calendarsData } = useAccessibleCalendars();
  
  const calendarNameMap = useMemo(() => {
    const map = new Map<string, string>();
    if (calendarsData) {
      calendarsData.calendars.forEach(cal => {
        map.set(cal.email, cal.name);
      });
    }
    return map;
  }, [calendarsData]);

  return { calendarNameMap, isLoading: !calendarsData };
};
